
export function userlogo(name) {
  if (!name) return "AB";

  let userLogo = name
    .split(" ")
    .map((n) => n[0])
    .join("");
  return userLogo == "" ? "AB" : userLogo;
}